<template>
    <v-select variant="outlined" density="compact" class="mx-1" v-model="scale" :items="scales"
        :label="t('PDF Rendering Scale')">
    </v-select>
</template>

<script>
import { usePitStoreBasics } from "@/stores/app_common";
export default {
    setup() {
        return { ...usePitStoreBasics(), } 
    },
    props: ["modelValue"],
    data: () => ({
        scale: 2,
    }),
    computed: {
        scales() {
            return [
                {
                    title: this.t("pdf_scale_025"),
                    value: 0.25,
                },
                {
                    title: this.t("pdf_scale_05"),
                    value: 0.5,
                },
                {
                    title: this.t("pdf_scale_1"),
                    value: 1,
                },
                {
                    title: this.t("pdf_scale_2"),
                    value: 2,
                },
                {
                    title: this.t("pdf_scale_4"),
                    value: 4,
                },
                {
                    title: this.t("pdf_scale_8"),
                    value: 8,
                },
            ];
        },
    },
    watch: {
        scale(v) {
            this.$emit("update:modelValue", v);
        },
        modelValue: {
            handler: function (v) {
                this.scale = v;
            },
            immediate: true,
        },
    },
};
</script>